import Vue from 'vue';
import TestEmailUnsubscribe from 'Unsubscribe/TestEmailUnsubscribe.vue';

new Vue({
  data() {
    return {};
  },
  components: {
    'test-email-unsubscribe': TestEmailUnsubscribe,
  },
  el: '#p2a-unsubscribe'
});